function drawerfunction(test){  

   $("#CartDrawer").addClass("loading-cart");
   $(".all-gifts-list .svg-with-id").each(function(){
       if($(this).find(".checkmark-icon").css("opacity") == "0") {        
         $(this).removeClass("active-value-js")          
       }
       else{
         $(this).addClass("active-value-js")         
       }
     });
var currency_rate = $('#currency_rate').attr('data_curre_id');
             var firstfreetotal = $('.firstfreetotal').val();
            // var secondfreetotal = $('.secondfreetotal').val();
            var thirdfreetotal = $('.thirdfreetotal').val();
              
            var firstfreepro = $('.firstfreepro').val();
            // var secondfreepro = $('.secondfreepro').val();
            var thirdfreepro = $('.thirdfreepro').val();

            var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').length;
            // var removepro2 = $('.progress-free-pro[data-product-index='+secondfreepro+']').length;
            var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').length;


            var pro1len = parseInt($('.firstfreepro').attr('data-length'));
            // var pro2len = parseInt($('.secondfreepro').attr('data-length'));
            var pro3len = parseInt($('.thirdfreepro').attr('data-length'));

            fetch('/cart.js')
            .then((resp) => resp.json())
            .then((cart) => {

             // console.log(cart.total_price)
              if(cart.items.length > 0){
                $('.main-cart-drawer').removeClass('is-empty');
              }
              if(cart.total_price > firstfreetotal){ 
                if(pro1len < 1){
                  $.ajax({
                  type: 'POST',
                  async: false,
                  url: '/cart/add.js',
                  data: {quantity: 1,id: firstfreepro,properties: {  "Product": "Free Gift"}   },
                  dataType: 'json',
                  success: function() {         
                    
                    $("cart-drawer").load(location.href + " cart-drawer>*","");
                   $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");  
                    $('.firstfreepro').attr('data-length' ,'1');       
                  },
                  error: function() {
                    // console.log('Error adding items to cart');
                  }
                });
               }
              }
              // if(cart.total_price > secondfreetotal){
              //   if(pro2len < 1){
              //   $.ajax({
              //   type: 'POST',
              //   async: false,
              //   url: '/cart/add.js',
              //   data: {quantity: 1,id: secondfreepro,properties: {  "Product": "Free Gift"}   },
              //   dataType: 'json',
              //   success: function() {         
                  
              //     $("cart-drawer").load(location.href + " cart-drawer>*","");
              //    $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
              //     $('.secondfreepro').attr('data-length' ,'1');         
              //   },
              //   error: function() {
              //     // console.log('Error adding items to cart');
              //   }
              // });
              //   }
              // }
              if(cart.total_price > thirdfreetotal){
                if(pro3len < 1){
                $.ajax({
                type: 'POST',
                async: false,
                url: '/cart/add.js',
                data: {quantity: 1,id: thirdfreepro,properties: {  "Product": "Free Gift"}   },
                dataType: 'json',
                success: function() {         
                  
                  $("cart-drawer").load(location.href + " cart-drawer>*","");
                 $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
                  $('.thirdfreepro').attr('data-length' ,'1');         
                },
                error: function() {
                  // console.log('Error adding items to cart');
                }
              });
                }
                
              }
            
            });
  // setTimeout(function(){
  //   $("#CartDrawer").removeClass("loading-cart");
  //   if($("cart-drawer .cart-drawer .cart-item").length == 0){
  //   $("cart-drawer").addClass("is-empty");
  //   }
  // },2000);
  setTimeout(function(){
    $("#CartDrawer").removeClass("loading-cart");
    if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
    }
  },3000);
  setTimeout(function(){
    $("#CartDrawer").removeClass("loading-cart");
    if($("cart-drawer .cart-drawer .cart-item").length == 0){
    $("cart-drawer").addClass("is-empty");
    }
  },6000);
}

function removefreefunction(removepro1,removepro3){ 

            var firstfreetotal = $('.firstfreetotal').val();
            // var secondfreetotal = $('.secondfreetotal').val();
            var thirdfreetotal = $('.thirdfreetotal').val();
              
            var firstfreepro = $('.firstfreepro').val();
            // var secondfreepro = $('.secondfreepro').val();
            var thirdfreepro = $('.thirdfreepro').val();


            var pro1len = parseInt($('.firstfreepro').attr('data-length'));
            // var pro2len = parseInt($('.secondfreepro').attr('data-length'));
            var pro3len = parseInt($('.thirdfreepro').attr('data-length'));


          fetch('/cart.js')
            .then((resp) => resp.json())
            .then((cart) => {
          if(cart.items.length > 0){
            $('.main-cart-drawer').removeClass('is-empty');
          }
            if(removepro3 != 'undefined'){
              if(cart.total_price < thirdfreetotal){
        
                          if(pro3len == 1){
                              $.ajax({
                              url: '/cart/change.js',
                              type: "post", 
                              dataType: 'json',
                              async:false, 
                              data: { 
                                "id": removepro3, // 'index' unique value 
                                "quantity": 0, // 'qty' Quantity
                                
                              },
                              success: function(cart){  
                                $("cart-drawer").load(location.href + " cart-drawer>*","");
                                $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");   
                                $('.thirdfreepro').attr('data-length' ,'0');
                                if ($('.cart-count-bubble').not(':visible')) {
                                 $('cart-drawer').addClass('is-empty');
                                }
                                setTimeout(function(){
                                  var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
                                  var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');
                                  removefreefunction(removepro1,removepro3);
                                },4000);
                              }
                            });
                         }
                     }
                }
              
              if(removepro1 != 'undefined'){

                 if(cart.total_price < firstfreetotal){
                     
                        if(pro1len == 1){
                            $.ajax({
                            url: '/cart/change.js',
                            type: "post", 
                            dataType: 'json',
                            async:false, 
                            data: { 
                              "id": removepro1, // 'index' unique value 
                              "quantity": 0, // 'qty' Quantity
                              
                    
                            },
                            success: function(cart){  
                              $("cart-drawer").load(location.href + " cart-drawer>*","");
                              $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
                              $('.firstfreepro').attr('data-length' ,'0'); 
                              if ($('.cart-count-bubble').not(':visible')) {
                                 $('cart-drawer').addClass('is-empty');
                              }
                              setTimeout(function(){
                                var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
                                var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');
                                removefreefunction(removepro1,removepro3);
                               },7000);
                            }
                          });
                        }
                   }
              }

            })

}
function cartfetch(){ 

          var firstfreepro = $('.firstfreepro').val();
          var thirdfreepro = $('.thirdfreepro').val();

          var firstfreetotal = $('.firstfreetotal').val();
          var thirdfreetotal = $('.thirdfreetotal').val();

          var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
          var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');
console.log(removepro1)
console.log(removepro3)

          fetch('/cart.js')
            .then((resp) => resp.json())
            .then((cart) => {
            if(cart.total_price ==  0){
              $.ajax({
                      type: "POST",
                      url: '/cart/clear.js',
                      data: '',
                      dataType: 'json',
                      async:false,
                      success: function() {
                           $("cart-drawer").load(location.href + " cart-drawer>*","");
                           $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
                          $('.main-cart-drawer').addClass('is-empty');
                      },
                      error: function(XMLHttpRequest, textStatus) {
                        /* error code */
                      }
                    });
           
              }

           if(cart.total_price < firstfreetotal){
                 if(removepro3 != undefined){
                        $.ajax({
                        url: '/cart/change.js',
                        type: "post", 
                        dataType: 'json',
                        async:false,
                        data: { 
                          "id": removepro3, // 'index' unique value 
                          "quantity": 0, // 'qty' Quantity
                        },
                        success: function(cart){  
                          $("cart-drawer").load(location.href + " cart-drawer>*","");
                          $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
                          $('.main-cart-drawer').addClass('is-empty');
                         
                        }
                      }); 
                    }
                     if(removepro1 != undefined){
                      $.ajax({
                      url: '/cart/change.js',
                      type: "post", 
                      dataType: 'json',
                      async:false,
                      data: { 
                        "id": removepro1, // 'index' unique value 
                        "quantity": 0, // 'qty' Quantity
                        
              
                      },
                      success: function(cart){  
                        $("cart-drawer").load(location.href + " cart-drawer>*","");
                        $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
                        $('.main-cart-drawer').addClass('is-empty');

                      }
                    });
                 }
               

             }
        
             if(cart.total_price < thirdfreetotal){
                   if(removepro3 != undefined){
                      $.ajax({
                      url: '/cart/change.js',
                      type: "post", 
                      dataType: 'json',
                      async:false,
                      data: { 
                        "id": removepro3, // 'index' unique value 
                        "quantity": 0, // 'qty' Quantity
                      },
                      success: function(cart){  
                        $("cart-drawer").load(location.href + " cart-drawer>*","");
                        $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*",""); 
                        $('.main-cart-drawer').addClass('is-empty');
                       
                      }
                    }); 
                }
             }

            })

}
// drawerfunction(1);


// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('click', (event) => {
//       event.preventDefault();
//       const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
//       cartItems.updateQuantity(this.dataset.index, 0);
//     });
//   }
// }

// customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
setTimeout(function(){
  drawerfunction(2);
  
},200);
//     setTimeout(function(){
//   drawerfunction(3);
  
// },300);
setTimeout(function(){
      $("cart-drawer").load(location.href + " cart-drawer>*","");
  $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
     },2500);  
 
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));

   
    setTimeout(function(){      
      $("cart-drawer").load(location.href + " cart-drawer>*","");
      $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*","");
     },2500);

    
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

$(document).on('click','.cart-remove-button', function(e) {
$('.main-cart-drawer').addClass('loading-data');
       $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition');
       setTimeout(function(){
          // drawerfunction(6);
            var firstfreepro = $('.firstfreepro').val();
            var secondfreepro = $('.secondfreepro').val();
            var thirdfreepro = $('.thirdfreepro').val();
            var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
            // var removepro2 = $('.progress-free-pro[data-product-index='+secondfreepro+']').data('line-id-cus');
            var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');

          // removefreefunction(removepro1,removepro2,removepro3);
              removefreefunction(removepro1,removepro3);
       },2000); 
       setTimeout(function(){
          drawerfunction(7);
       },2500);
      setTimeout(function(){
          cartfetch(); 
        
      },6000);
      setTimeout(function(){
          cartfetch(); 
        
      },8000);
      
    setTimeout(function(){
        // $('.main-cart-drawer .new-product-item').slick('setPosition'); 
        $('.main-cart-drawer').removeClass('loading-data');
      },3000);
    // setTimeout(function(){
    //         progressBar();
    //      },9000);
});

  $(document).on('click','.quantity__button',function () {
    $('.main-cart-drawer').addClass('loading-data');
     setTimeout(function(){
          // drawerfunction(8);
            var firstfreepro = $('.firstfreepro').val();
            var secondfreepro = $('.secondfreepro').val();
            var thirdfreepro = $('.thirdfreepro').val();
            var removepro1 = $('.progress-free-pro[data-product-index='+firstfreepro+']').data('line-id-cus');
            // var removepro2 = $('.progress-free-pro[data-product-index='+secondfreepro+']').data('line-id-cus');
            var removepro3 = $('.progress-free-pro[data-product-index='+thirdfreepro+']').data('line-id-cus');

          // removefreefunction(removepro1,removepro2,removepro3);
          removefreefunction(removepro1,removepro3);
       $("#main-cart-items").load(location.href + " #main-cart-items>*","");
       // $('.main-cart-drawer .new-product-item').slick('setPosition');
       },1000);    
      setTimeout(function(){
          drawerfunction(9);
        $("#main-cart-items").load(location.href + " #main-cart-items>*","");
        // $('.main-cart-drawer .new-product-item').slick('setPosition');
       },2500);
      setTimeout(function(){
        $('.main-cart-drawer .new-product-item').slick('setPosition');
        $('.main-cart-drawer').removeClass('loading-data');
      },3000);
      // setTimeout(function(){
      //       progressBar();
      //    },5000);
    
  });